export const statisticsActionTypes = {
   // STATISTICS HISTORY TYPES
   UPDATE_HISTORY_LOG: "UPDATE_HISTORY_LOG",
   RESET_HISTORY_LOG: "RESET_HISTORY_LOG",
};
